import Autocomplete from 'react-google-autocomplete';

const AddressAutocomplete = (props) => {
    const apiKey = process.env.REACT_APP_GOOGLE_KEY;
    const options = {
        types: ['address'],
        componentRestrictions: { country: 'ca' }
    }

    return(
        <Autocomplete
            className="form-control"
            apiKey = { apiKey }
            options = { options }
            defaultValue = { props.currAddress }
            onPlaceSelected={ (place) => props.saveAddress(place) }
        />
    );
}

export default AddressAutocomplete;